import { configureStore } from "@reduxjs/toolkit";
import FormSliceReducer from "./slices/form.slice";
import { listenerMiddleware } from "./listener-middleware";

const FormStore = configureStore({
  reducer: {
    form: FormSliceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).prepend(listenerMiddleware.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof FormStore.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof FormStore.dispatch;

// Register side-effect listeners. Imported after types are declared so the
// listener module's type-only import of RootState/AppDispatch resolves cleanly.
import "./listeners/form.listener";

export default FormStore;
